import React, { useEffect, useState } from "react";
import styled from "styled-components";

import CheckIcon from "../../assets/grey_checked_icon.svg";
import CheckActiveIcon from "../../assets/ico_blue_check_circle.png";
import { collectionConsentTerm, marketingTerm, serviceTerm, LocationServiceTerm } from "../..//constants/URLs";
import { Common } from "../../styles/Common";

const termList = [
    {
        isChecked: false,
        isRequire: true,
        title: "서비스 이용약관",
        link: serviceTerm,
    },
    {
        isChecked: false,
        isRequire: true,
        title: "개인정보 수집 및 이용",
        link: collectionConsentTerm,
    },
    {
        isChecked: false,
        isRequire: true,
        title: "위치기반 서비스 이용약관",
        link: LocationServiceTerm,
    },
    {
        isChecked: false,
        isRequire: false,
        title: "매물정보 및 광고성 정보 수신",
        link: marketingTerm,
    },
];

const TERM_MARKETING_INDEX = termList.length - 1;

interface Props {
    onCheckRequiredTerms: (isChecked: boolean) => void;
    onCheckMarketingTerms: (isChecked: boolean) => void;
}

const AgreementTermBox: React.FC<Props> = ({ onCheckRequiredTerms, onCheckMarketingTerms }) => {
    const [agreementTerms, setAgreementTerms] = useState(termList);

    const handleCheckTerm = (index: number) => {
        const newCheckTerms = [...agreementTerms].map((t, i) => ({
            ...t,
            isChecked: i === index ? !t.isChecked : t.isChecked,
        }));
        setAgreementTerms(newCheckTerms);
    };
    const handleAllCheckTerms = () => {
        if (agreementTerms.every((term) => term.isChecked)) {
            setAgreementTerms(
                agreementTerms.map((term) => ({
                    ...term,
                    isChecked: false,
                })),
            );
        } else {
            setAgreementTerms(
                agreementTerms.map((term) => ({
                    ...term,
                    isChecked: true,
                })),
            );
        }
    };

    const handleMoreTerm = (link: string) => {
        const left = window.innerWidth / 2;
        const top = window.innerHeight / 2 - 400;
        const option = `location=no,toolbar=no,scrollbars=no,resizable=no,menubar=no,width=1080,height=800,top=${top},left=${left}`;
        window.open(link, "term", option);
    };

    useEffect(() => {
        if (agreementTerms[TERM_MARKETING_INDEX].isChecked) {
            onCheckMarketingTerms(true);
        } else {
            onCheckMarketingTerms(false);
        }

        if (agreementTerms.filter((term) => term.isRequire).every((term) => term.isChecked)) {
            onCheckRequiredTerms(true);
        } else {
            onCheckRequiredTerms(false);
        }
    }, [agreementTerms]);

    return (
        <div className="checkList">
            <p className="checkListTitle">약관 동의</p>
            <AllTermBoxStyle onClick={handleAllCheckTerms}>
                <CheckBoxStyle
                    src={agreementTerms.every((term) => term.isChecked) ? CheckActiveIcon : CheckIcon}
                    alt="전체 동의 체크박스"
                    width={20}
                    height={20}
                />
                <p className="allCheckedText" aria-hidden onClick={handleAllCheckTerms}>
                    약관에 모두 동의
                </p>
            </AllTermBoxStyle>
            {agreementTerms.map((term, idx) => (
                <TermSubBoxStyle key={term.title}>
                    <TermBoxStyle>
                        <CheckBoxStyle
                            src={term.isChecked ? CheckActiveIcon : CheckIcon}
                            alt="체크 박스"
                            width={16}
                            height={16}
                            onClick={() => handleCheckTerm(idx)}
                        />

                        <p className="titleText" aria-hidden onClick={() => handleCheckTerm(idx)}>
                            {term.title}
                            <span className="requireText">({term.isRequire ? "필수" : "선택"})</span>
                        </p>
                    </TermBoxStyle>

                    <p className="moreIcon" onClick={() => handleMoreTerm(term?.link)}>
                        {">"}
                    </p>
                </TermSubBoxStyle>
            ))}
            <FooterTextStyle>
                선택 항목을 동의하지 않아도 서비스를 이용하실 수 있습니다
                <br />
                단, 필수 항목의 동의 거부 시에는 가입이 불가합니다
            </FooterTextStyle>
        </div>
    );
};

export default AgreementTermBox;

const TermBoxStyle = styled.div`
    display: flex;
    align-items: center;
    padding: 2px 15px;
    font-size: 14px;
    gap: 8px;
    color: #8d8d8d;
    line-height: 26px;

    .requireText {
        color: #8d8d8d;
        margin-left: 8px;
    }
    .titleText {
        cursor: pointer;
    }
`;

const AllTermBoxStyle = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 14px;
    border: 1px solid #dddddd;
    border-radius: 8px;
    gap: 8px;
    cursor: pointer;
    margin-top: 10px;
    margin-bottom: 10px;
    .allCheckedText {
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        color: ${Common.colors.normalTextColor};
    }
`;
const TermSubBoxStyle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 12px;
    .moreIcon {
        cursor: pointer;
        color: #8d8d8d;
        font-size: 10px;
    }
`;

const CheckBoxStyle = styled.img`
    cursor: pointer;
`;

const FooterTextStyle = styled.p`
    font-weight: 400;
    font-size: 12px;
    color: #a3a3a3;
    margin-bottom: 48px;
    line-height: 18px;
    padding: 0 8px;
    margin-top: 10px;

    @media screen and (max-width: 768px) {
        margin-bottom: 36px;
    }
`;
